export default __webpack_public_path__ + "static/media/Mascote1.8ecb49d7.png";